export const CHAT_MESSAGE_TYPE = {
  received: "received",
  sent: "sent",
};
